export const PREVIEW_TYPE = {
    ONBOARDING: 'preview-onboarding',
    TEST: 'preview-test',
} as const;

export type PreviewType = (typeof PREVIEW_TYPE)[keyof typeof PREVIEW_TYPE];
